import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import Item from './item';
import '../../styles/itens.scss';

async function getItens() {
    let response = await fetch('https://prefeituramacuco.rj.gov.br/transparencia/api/itens.json')
    let data = await response.json()
    return data
}


const Itens = () => {
    const [itens, setItens] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        getItens().then(data => {
            setItens(data['itens'])
        })
    }, [])

    const filteredItens = itens.filter(item => item.titulo.toLowerCase().includes(searchTerm.toLowerCase()));
    return (
        <Fragment>
            <Container>
                <Row xs={1}>
                    <Col xs={12}>
                        <div className="filtra_lic">
                            <div className="titulo-home">Sobre a Lei de Acesso à Informação</div>
                            <div className="conteudo-lic">
                                A <a href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm" rel="noreferrer" target="_blank">Lei nº 12.527</a> de 2011, conhecida como Lei de Acesso à Informação (LAI), regulamentou o direito constitucional de qualquer pessoa solicitar informações a órgãos e entidades públicas de todas as esferas e Poderes. As informações de interesse coletivo ou geral devem ser divulgadas de ofício pelos órgãos públicos, espontânea e proativamente, independentemente de solicitações. Além disso, o art. 8º da Lei prevê um rol mínimo de informações que os órgãos e entidades públicas devem obrigatoriamente divulgar na internet.
                                <br /><br />
                                A Prefeitura de Macuco, comprometida com o fortalecimento das políticas de transparência pública, disponibiliza esta seção em seu Portal na Internet, com vistas a garantir e facilitar o acesso às informações públicas de sua competência.
                                <br /><br />
                                Se não for possível encontrar a informação desejada em nenhuma das seções deste Portal, basta solicitá-la através do nosso <a href="https://prefeituramacuco.rj.gov.br/esic" rel="noreferrer" target="_blank">Sistema Eletrônico de Informação ao Cidadão (e-SIC)</a>.
                                <br /><br />
                                <strong>Links externos relacionados à Lei de Acesso à Informação:</strong>
                                <br /><br />
                                <a href="https://prefeituramacuco.rj.gov.br/transparencia/leis/transparencia" rel="noreferrer" target="_blank">Legislação Municipal de Transparência e Acesso à informação.</a><br />
                                <a href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm" rel="noreferrer" target="_blank">Lei Federal 12.527/2011 - Regula o acesso às informações de interesse público.</a><br />
                                <a href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/decreto/d7724.htm" rel="noreferrer" target="_blank">Decreto Federal 7.724/2012 - Regula o acesso à informação no âmbito do Poder Executivo Federal.</a><br />
                                <a href="http://www.portaltransparencia.gov.br/" rel="noreferrer" target="_blank">Portal da Transparência do Governo Federal.</a><br />
                                <a href="http://www.transparencia.rj.gov.br/" rel="noreferrer" target="_blank">Portal da Transparência do Governo Estadual.</a><br />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row xs={1}>
                    <Col xs={12}>
                        <Form.Group>
                            <Form.Control
                                type="text"
                                placeholder="Digite a palavra-chave para buscar..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row xs={1} lg={3}>
                    {filteredItens.map((item, index) =>
                        <Col lg={4}>
                            <Item
                                titulo={item.titulo}
                                descricao={item.descricao}
                                awesome={item.awesome}
                                img={item.img}
                                link={item.link}
                                key={index}
                            />
                        </Col>
                    )}
                </Row>

            </Container>
        </Fragment>
    )

}

export default Itens;